'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

function replaceOrAddQueryParam (url, parameter, value) {
    var regex = new RegExp(parameter + '=[^&]+');
    var split = url.split(regex);
    if (split.length > 1) {
        return split[0] + (url.indexOf('?') > -1 ? '' : '?') + parameter + '=' + value + split[1];
    } else {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + parameter + '=' + value;
    }
};

function getQueryParams() {
    var url = document.location.href;
    var qs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0, result = {}; i < qs.length; i++) {
        qs[i] = qs[i].split('=');
        result[qs[i][0]] = decodeURIComponent(qs[i][1]);
    }
    return result;
};

module.exports = {
    replaceOrAddQueryParam: replaceOrAddQueryParam,
    getQueryParams: getQueryParams,
    appendToUrl: appendToUrl
};
